import React from 'react';
import { connect } from 'react-redux';
import OrgsTable from './OrgsTable';

import Collapsible from '../../util/Collapsible';

const OrgsOverview = ({ scrollTop, defaultOpen }) => (
  <Collapsible headerContent="Organizations" defaultOpen={defaultOpen}>
    <OrgsTable scrollTop={scrollTop} />
  </Collapsible>
);

export default connect(
  ({
    users: {
      editing: { editType },
    },
  }) => ({
    defaultOpen: editType === 'NONE' || editType === 'ORG',
  })
)(OrgsOverview);
